import * as React from 'react'
import { SVGProps } from 'react'

const VisaCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-name="Group 52844" xmlns="http://www.w3.org/2000/svg" width={62} height={40} {...props}>
    <g data-name="Rectangle 3289" fill="none" stroke="#d3dade" strokeLinecap="round">
      <rect width={62} height={40} rx={4} stroke="none" />
      <rect x={0.5} y={0.5} width={61} height={39} rx={3.5} />
    </g>
    <g data-name="Group 52835" fill="#13278a">
      <path d="M28.805 25.695H25.94l1.792-11.079h2.865ZM39.579 14.886a7.059 7.059 0 0 0-2.569-.472c-2.829 0-4.821 1.509-4.833 3.665-.023 1.591 1.426 2.475 2.51 3.006 1.108.542 1.485.9 1.485 1.379-.011.742-.9 1.084-1.72 1.084a5.7 5.7 0 0 1-2.688-.589l-.377-.177-.4 2.487a8.719 8.719 0 0 0 3.195.59c3.006 0 4.963-1.485 4.986-3.784.012-1.261-.754-2.228-2.4-3.017-1-.507-1.615-.849-1.615-1.367.012-.472.519-.954 1.65-.954a4.866 4.866 0 0 1 2.134.424l.259.118.39-2.392ZM43.944 21.77c.236-.636 1.144-3.1 1.144-3.1-.012.024.235-.648.377-1.061l.2.955s.542 2.652.66 3.206Zm3.536-7.154h-2.216a1.414 1.414 0 0 0-1.5.919l-4.255 10.16h3.006l.6-1.662h3.678c.082.389.342 1.662.342 1.662h2.655l-2.311-11.079ZM23.111 14.616l-2.805 7.555-.307-1.532a8.48 8.48 0 0 0-3.96-4.644l2.57 9.688h3.029l4.5-11.067Z" />
      <path d="M17.464 14.616h-4.609l-.047.224a9.585 9.585 0 0 1 6.954 5.8l-1-5.092a1.185 1.185 0 0 0-1.3-.931Z" />
    </g>
  </svg>
)

export default VisaCardIcon
